import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-module-filter',
  templateUrl: './module-filter.component.html',
  styleUrls: ['./module-filter.component.scss']
})
export class ModuleFilterComponent {
  @Input() public moduleFormGroup!: FormGroup;
  @Output() filterModules = new EventEmitter<FormGroup>();

  constructor() {
  }

  onCancel(): void {
  }

  onChange() {
    this.filterModules.emit(this.moduleFormGroup);
  }
}
